import { objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Box, Flex, Switch } from '@chakra-ui/react';
import { Checkbox } from '../Checkbox/component.js';
import { Radio } from '../Radio/component.js';
var SelectionControl = function SelectionControl(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    hideLabel = props.hideLabel,
    name = props.name,
    inputRef = props.inputRef,
    id = props.id,
    key = props.key,
    onChange = props.onChange,
    onClick = props.onClick,
    labelAction = props.labelAction,
    _props$padding = props.padding,
    userPadding = _props$padding === undefined ? {} : _props$padding,
    isChecked = props.isChecked,
    stacked = props.stacked,
    type = props.type,
    value = props.value,
    toggleLabelSide = props.toggleLabelSide,
    label = props.label;
  var padding = _objectSpread2(_objectSpread2({}, {
    pt: 0,
    pr: 4,
    pb: 0,
    pl: 0
  }), userPadding);
  var currentType = type;
  if (type === 'checkbox' || type === 'option') {
    currentType = 'checkbox';
  } else if (type === 'switch' || type === 'toggle') {
    currentType = 'toggle';
  }
  var filteredDataAttibsInputProps = function filteredDataAttibsInputProps() {
    // This will be props for the input of the Chakra component (inputProps).
    // Filter out anything other than data attributes to avoid errors.
    var result = {};
    for (var _key in props) {
      if (_key.startsWith('data-')) {
        result[_key] = props[_key];
      }
    }
    /**
     * The currentType will, in the end, only be checkbox, radio, or toggle
     * to keep it predictible for testing suits
     */
    result['data-component-type'] = currentType;
    return result;
  };
  var isItChecked = isChecked !== null && isChecked !== undefined ? isChecked : false;
  var commonProps = _objectSpread2({
    isDisabled: isDisabled,
    name: name,
    ref: inputRef,
    id: id,
    key: key,
    onChange: onChange,
    isChecked: isItChecked,
    'data-action': labelAction,
    value: value
  }, filteredDataAttibsInputProps());
  var renderElement = function renderElement() {
    if (currentType === 'checkbox') {
      return /*#__PURE__*/React.createElement(Box, padding, /*#__PURE__*/React.createElement(Flex, {
        align: "start"
      }, /*#__PURE__*/React.createElement(Box, {
        alignItems: stacked ? 'center' : 'left'
      }, /*#__PURE__*/React.createElement(Checkbox, _extends({
        label: label,
        gap: "2"
      }, commonProps, {
        variant: stacked ? 'stacked' : undefined
      }), children))));
    } else if (currentType === 'radio') {
      return /*#__PURE__*/React.createElement(Flex, {
        align: stacked ? 'center' : 'start',
        direction: stacked ? 'column' : 'row'
      }, /*#__PURE__*/React.createElement(Radio, _extends({
        label: label,
        gap: "2"
      }, commonProps, {
        onClick: onClick,
        role: "radio",
        variant: stacked ? 'stacked' : undefined
      }), children));
    } else if (currentType === 'toggle') {
      var labelSide = children && !toggleLabelSide ? 'right' : toggleLabelSide;
      labelSide = !hideLabel && React.Children.count(children) > 0 ? labelSide : '';
      return /*#__PURE__*/React.createElement(Box, _extends({
        display: "flex",
        alignItems: "center"
      }, padding), /*#__PURE__*/React.createElement(Flex, {
        align: stacked ? 'center' : 'start',
        direction: stacked ? 'column' : 'row'
      }, labelSide === 'left' && /*#__PURE__*/React.createElement(Box, _extends({
        mr: "2"
      }, filteredDataAttibsInputProps()), children), /*#__PURE__*/React.createElement(Switch, commonProps), labelSide === 'right' && /*#__PURE__*/React.createElement(Box, _extends({
        ml: "2",
        mt: stacked ? 2 : 0
      }, filteredDataAttibsInputProps()), children)));
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderElement());
};
export { SelectionControl };